import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import InsuranceEditModal from '../../../../components/InsuranceEditModal';
import * as api from '../../../../services/api/admin';

class Insurances extends Component {
  state = {
    isLoading: true,
    insurances: [],
    openInsuranceEditModal: false,
    insuranceUnderEdit: {},
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      await this.fetchInsurances();
    } catch (err) {
      console.error(err);
      this.props.enqueueSnackbar(
        'Unable to fetch insurances, please refresh the page to try again.'
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  fetchInsurances = async () => {
    const insurances = await api.fetchInsurances();
    this.setState({ insurances });
  };

  onEdit = insurance => {
    this.setState({ openInsuranceEditModal: true, insuranceUnderEdit: insurance });
  };

  onNew = () => {
    this.onEdit({});
  };

  onSave = async insurance => {
    const { enqueueSnackbar } = this.props;

    try {
      if (insurance.id) {
        await api.updateInsurance(insurance);
      } else {
        await api.createInsurance(insurance);
      }
      enqueueSnackbar('Insurance updated!');
      this.onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to save insurance, please try again.');
    } finally {
      this.fetchInsurances();
    }
  };

  onClose = () => {
    this.setState({ openInsuranceEditModal: false, insuranceUnderEdit: {} });
  };

  render() {
    const { classes } = this.props;
    const { isLoading, insurances, openInsuranceEditModal, insuranceUnderEdit } = this.state;

    if (isLoading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Short Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {insurances.map(insurance => (
              <TableRow key={insurance.id}>
                <TableCell width="300">{insurance.name}</TableCell>
                <TableCell width="300">{insurance.shortName}</TableCell>
                <TableCell>
                  <IconButton onClick={() => this.onEdit(insurance)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Grid
          container
          justifyContent="flex-end"
          classes={{ container: classes.actions }}
        >
          <Grid item xs={12} md={4} lg={2}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.onNew}
            >
              + Add Insurance
            </Button>
          </Grid>
        </Grid>

        {openInsuranceEditModal && (
          <InsuranceEditModal
            insurance={insuranceUnderEdit}
            open={openInsuranceEditModal}
            save={this.onSave}
            onClose={this.onClose}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actions: {
    marginTop: '2em',
  },
});

export default withSnackbar(withStyles(styles)(Insurances));
